// ------------------------------------------------------------------------------
// RingSteps - 圆环图标效果的 Steps（天工统一网格）
// author: mudas
// created: 2025/3/11
// ------------------------------------------------------------------------------

import React, { FC } from 'react';

import { ConfigProvider, Steps, StepsProps } from '@fuxi/eevee-ui';

import cx from './RingSteps.module.css';

export interface IProps extends StepsProps {}

const RingSteps: FC<IProps> = props => {
  const { items, ...stepProps } = props;

  return (
    <ConfigProvider
      theme={{
        components: {
          Steps: {
            dotSize: 14,
            dotCurrentSize: 14,
            iconTop: -1,
            controlHeight: 26,
            paddingXS: 0,
            lineWidth: 2,
          },
        },
      }}>
      <Steps
        className={cx('ring-steps')}
        direction="vertical"
        size="small"
        items={items}
        progressDot={(dot, { index }) => {
          return index === items!.length - 1 ? (
            <div className="w-14px h-14px rounded-full bg-primary" />
          ) : (
            <div className="w-14px h-14px rounded-full b-2 b-solid border-color-primary" />
          );
        }}
        {...stepProps}
      />
    </ConfigProvider>
  );
};

export default RingSteps;
